// src/scripts/utils/utils.ts
var nextArrow = '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="20" height="20" viewBox="0 0 9 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.19846 2.20215L7.03281 10.4L0.198459 18.5978C-0.103673 18.9607 -0.0540742 19.4988 0.30779 19.8015C0.669654 20.1042 1.20938 20.0551 1.51152 19.6927L8.8016 10.9474C8.9344 10.789 9 10.5944 9 10.4C9 10.2053 8.9344 10.0109 8.8016 9.8525L1.51152 1.10722C1.20939 0.744821 0.669922 0.695756 0.307791 0.99842C-0.0551391 1.30162 -0.104205 1.83868 0.19846 2.20215Z" /></svg></button>';
var prevArrow = `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg width="20" height="20" viewBox="0 0 9 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.80154 17.7979L1.96719 9.60004L8.80154 1.40223C9.10367 1.0393 9.05407 0.50117 8.69221 0.198505C8.33035 -0.104159 7.79062 -0.0550929 7.48848 0.307305L0.198397 9.05258C0.0655979 9.21098 -1.52707e-06 9.40564 -1.55863e-06 9.60004C-1.59024e-06 9.79471 0.0655978 9.98911 0.198397 10.1475L7.48848 18.8928C7.79061 19.2552 8.33008 19.3042 8.69221 19.0016C9.05514 18.6984 9.1042 18.1613 8.80154 17.7979Z"/></svg></button>`;

// src/components/article-modal.ts
var ArticleModal = class extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.projectData = [];
    this.activeImage = null;
    this.activeSlideElement = null;
    this.activePhotographerLink = null;
    this.activePhotographerName = null;
    this.pinterestLinkElement = null;
    this.activeSlideElement = this.querySelector("#active-slide");
    this.activePhotographerLink = this.querySelector("#active-photographer");
    if (this.activePhotographerLink) {
      this.activePhotographerName = this.activePhotographerLink.querySelector("#name");
    }
    this.projectData = JSON.parse(
      this.querySelector("#project-data").textContent
    );
    this.initCarousel = this.initCarousel.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.updateActiveSlide = this.updateActiveSlide.bind(this);
  }
  connectedCallback() {
    this.initTriggers();
    this.initCarousel();
    this.handleOutSideClick();
  }
  initTriggers() {
    document.querySelectorAll("[data-modal-trigger]").forEach((button) => {
      this.activeImage = parseInt(button.dataset.slideId);
      button.addEventListener("click", this.toggleModal);
    });
  }
  initCarousel() {
    const $modalCarousel = $(this).find("[data-article-modal-carousel]");
    $modalCarousel.slick({
      dots: false,
      infinite: true,
      adaptiveHeight: true,
      prevArrow,
      nextArrow,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            arrows: false
          }
        }
      ]
    });
    $modalCarousel.on("afterChange", (a, b, currentSlide) => {
      this.updateActiveSlide(currentSlide);
    });
  }
  updateActiveSlide(slide) {
    const activeSlide = slide + 1;
    this.activeSlideElement.textContent = activeSlide.toString();
    const data = this.projectData.find(
      ({ id }) => parseInt(id) === activeSlide
    );
    if (data) {
      this.activePhotographerLink.href = data.photographer.website_url;
      this.activePhotographerName.textContent = data.photographer.name;
    }
  }
  handleOutSideClick() {
    const container = this.querySelector(".article-modal__container");
    this.addEventListener("click", (e) => {
      const element = e.target;
      const clickedInSideElement = container.contains(element);
      const isContainer = element === container;
      if (clickedInSideElement || isContainer)
        return;
      this.isOpen = false;
      this.classList.remove("active");
      document.body.classList.remove("no-scroll");
    });
  }
  toggleModal() {
    this.isOpen = !this.isOpen;
    this.classList.toggle("active");
    document.body.classList.toggle("no-scroll");
  }
};
window.customElements.define("article-modal", ArticleModal);
